import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./slice/cartSlice";
import counterSlice from "./slice/counterSlice";

export const store = configureStore({
    reducer: {
        cart: cartReducer,
        count: counterSlice,
    },
    devTools: true
},
);